import React, { useEffect, useState } from "react";
import Map, { Marker } from "react-map-gl";
import axios from "axios";
import "./index.css";
import { useNavigate } from "react-router-dom";
import "mapbox-gl/dist/mapbox-gl.css";
import { baseSocketUrl, baseUrl } from "../../constants";

var cmodel = null;
const Maps = ({ navSelected, val, dateFilter }) => {
  const [lat, setLat] = useState(23.52397443761795);
  const [lng, setLng] = useState(-28.85205304506214);
  const [zoom, setZoom] = useState(1);
  const [indexs, setIndex] = useState(-1);
  const navigate = useNavigate();
  const [socketData, setSocketData] = useState([]);
  const [socketStatusData, setStatusSocketData] = useState({});

  const getJwtToken = () => {
    let token = localStorage.getItem("token") || undefined;
    return token === undefined ? "" : `${JSON.parse(token)}`;
  };

  // console.log(navSelected)

  useEffect(() => {
    if (navSelected !== undefined) {
      if (navSelected.show === true) {
        if (navSelected.prev === "*") {
          setZoom(2);
        } else {
          const url = `https://api.geoapify.com/v1/geocode/search?text=${navSelected.prev}&apiKey=071deb21657044b195207e793b1c9514`;
          axios.get(url).then((res) => {
            // console.log(res.data.features[0].geometry.coordinates[0]);
            console.log(res.data);

            setLng(res.data.features[0].geometry.coordinates[0]);
            setLat(res.data.features[0].geometry.coordinates[1]);
            if (navSelected.type == "country") setZoom(1);
            else if (navSelected.type == "state") setZoom(3);
            else setZoom(5);
          });
        }
      } else {
        const url = `https://api.geoapify.com/v1/geocode/search?text=${navSelected.val}&apiKey=071deb21657044b195207e793b1c9514`;
        axios.get(url).then((res) => {
          // console.log(res.data.features[0].geometry.coordinates[0]);
          console.log(res.data);

          setLng(res.data.features[0].geometry.coordinates[0]);
          setLat(res.data.features[0].geometry.coordinates[1]);
          if (navSelected.type == "country") setZoom(3);
          else if (navSelected.type == "state") setZoom(5);
          else setZoom(8);
        });
      }
    }
  }, [navSelected]);

  const [style, setStyle] = useState({
    display: "none",
    transition: "500ms all ease-in-out",
  });

  useEffect(() => {
    if (indexs !== -1)
      setStyle({ display: "block", transition: "500ms all ease-in-out" });
  }, [indexs]);

  const [vehicleDatas, setVehicleDatas] = useState([
    {
      online: 0,
      latitude: 40.6643,
      longitude: -73.9385,
      vehiclemodel: "error",
      registrationno: "KA01DV5347",
      vin: "3FADP4AZA4TY",
    },
    {
      online: 0,
      latitude: 34.0194,
      longitude: -118.4108,
      vehiclemodel: "error",
      registrationno: "KA01DV5347",
      vin: "3FADP4FJ2BM113913",
    },
    {
      online: 0,
      latitude: 41.8376,
      longitude: -87.6818,
      vehiclemodel: "error",
      registrationno: "KA01DV5347",
      vin: "MALC181C2JM450208",
    },
  ]);

  useEffect(() => {
    const getDatafromSocket = () => {
      const viin = { vehiclemodel: val == undefined ? null : val };
      var socket = new WebSocket(baseSocketUrl + "/map/");
      // console.log(socket)
      socket.onopen = () => {
        console.log("connection success");
        socket.send(JSON.stringify(viin));
      };
      socket.onmessage = function (event) {
        if (JSON.parse(event.data) !== "Send vin") {
          const carData = JSON.parse(event.data);
          setSocketData(carData);
          console.log(carData);
        }
      };
    };

    getDatafromSocket();
  }, [val]);

  useEffect(() => {
    const paramSocket = {
      country_id: null,
      state_id: null,
      city_id: null,
      vehiclemodel: val === undefined ? null : val,
    };
    var onlineSocket = new WebSocket(baseSocketUrl + "/devicestate/");
    onlineSocket.onopen = () => {
      console.log("online status connected");
      onlineSocket.send(JSON.stringify(paramSocket));
    };
    onlineSocket.onmessage = function (event) {
      const datastatus = JSON.parse(event.data);
      if (cmodel === val) console.log(datastatus);
      setStatusSocketData(datastatus);
    };
  }, []);

  useEffect(() => {
    const vdatas = vehicleDatas;
    console.log(socketStatusData);
    vdatas.map((vdata, index) => {
      vdata.online = socketStatusData[vdata.vin];
    });
    console.log(vdatas);
    setVehicleDatas(vdatas);
  }, [socketStatusData]);

  useEffect(() => {
    if (socketData !== null) {
      const temp = socketData;
      console.log(temp);

      if (temp !== "Connection Successful." && temp.length > 0) {
        temp.map((tempval) => {
          const laat = tempval.latitude;
          const loong = tempval.longitude;
          const viin = tempval.vin;
          const nna = tempval.vehicle_model;
          const rgn = tempval.registration_number;

          const vdatas = vehicleDatas;
          vdatas.map((vdata, index) => {
            if (
              vdata.vin === viin &&
              laat !== undefined &&
              Math.abs(laat) <= 90 &&
              Math.abs(loong) <= 180
            ) {
              vdata.latitude = laat;
              vdata.longitude = loong;
              vdata.vehiclemodel = nna;
              vdata.registrationno = rgn;
            }
          });
          console.log(vdatas);
          setVehicleDatas(vdatas);
        });
      }
    }
  }, [socketData]);

  const url = baseUrl + "/basicDetails/map/data/";

  useEffect(() => {
    const fetchModel = async () => {
      await axios
        .post(url, null, {
          headers: { Authorization: `Bearer ${getJwtToken()}` },
        })
        .then((res) => {
          const temp = res.data.result;
          setVehicleDatas(temp);
          // console.log(temp);
          // const vdatas = vehicleDatas;
          // temp.map((tempval) => {

          //   const laat = tempval.latitude;
          //   const loong = tempval.longitude;
          //   if(laat !== undefined && Math.abs(laat)<=90 && Math.abs(loong)<=180) {
          //     setLat(laat);
          //     setLng(loong);
          //   }
          // })

          //   const viin = tempval.vin
          //   const nna = tempval.vehiclemodel;
          //   const rgn = tempval.registrationno;

          //   vdatas.map((vdata, index) => {

          //     if(vdata.vin === viin && Math.abs(laat)<=90 && Math.abs(loong)<=180) {
          //       vdata.latitude = laat;
          //       vdata.longitude = loong;
          //       vdata.name = nna;
          //       vdata.regno = rgn;
          //     }

          //   })
          // })

          // setVehicleDatas(vdatas);
          // console.log(vdatas)
        })
        .catch(() => {
          // localStorage.removeItem("token");
          // localStorage.removeItem("username");
          // navigate("/login");
        });
    };

    fetchModel();
    // console.log(vehicleDatas)
  }, [val, dateFilter]);

  const [viewport, setViewPort] = useState({
    longitude: lng,
    latitude: lat,
    width: "28vw",
    height: "80vh",
    borderRadius: "14px",
    zoom: zoom,
  });

  useEffect(() => {
    setViewPort({
      longitude: lng,
      latitude: lat,
      width: "50vw",
      height: "57vh",
      borderRadius: "14px",
      zoom: zoom,
    });
  }, [lat, lng, zoom]);

  const _rendervehiclemarker = (vehicle, index) => {
    return (
      <>
        {Math.abs(vehicle.latitude) <= 90 &&
        Math.abs(vehicle.longitude) <= 180 ? (
          <Marker
            key={`marker-${index}`}
            longitude={vehicle.longitude}
            latitude={vehicle.latitude}
          >
            <div>
              <div
                style={
                  indexs === index
                    ? style
                    : { display: "none", transition: "400ms all ease" }
                }
                className="map_vehicle_box"
              >
                <div className="map_vehicle_name">{vehicle.vehicle_model}</div>
                <div className="map_vehicle_regno">
                  Reg. no. {vehicle.registration_number}
                </div>
                <div className="map_vehicle_status">
                  Status:{" "}
                  <div className="map_vehicle_online">
                    {vehicle.online === 1 ? "online" : "offline"}
                  </div>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: vehicle.online
                    ? "rgba(183, 217, 126, 0.3)"
                    : "rgba(168, 168, 168, 0.3)",
                  padding: "20px",
                  borderRadius: "50%",
                }}
                onClick={() => {
                  navigate(
                    `/dashboard/home/model/${vehicle.vin}/vehicleDashboard/`
                  );
                  localStorage.setItem("selectedModel", vehicle.vehiclemodel);
                }}
                onMouseEnter={(e) => {
                  setIndex(index);
                  console.log("hi");
                  // setStyle({display: 'block'});
                }}
                onMouseLeave={(e) => {
                  setIndex(-1);
                  // setStyle({display: 'none'})
                }}
              >
                <div
                  style={{
                    backgroundColor: vehicle.online ? "#93BA45" : "#E2E2E2",
                    padding: "10px",
                    borderRadius: "50%",
                    boxShadow: "0px 8px 10px rgba(0, 0, 0, 0.23)",
                  }}
                >
                  <svg
                    width="30"
                    height="20"
                    viewBox="0 0 40 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M33.579 8.30767L34.8788 7.89229C35.0955 7.78844 35.3121 7.89229 35.4204 7.99613C35.637 8.20383 35.637 8.41152 35.4204 8.61921L34.9871 9.34613L33.579 8.30767Z"
                      fill="#CC291F"
                    />
                    <path
                      opacity="0.39"
                      d="M33.579 8.30767L34.8788 7.89229C35.0955 7.78844 35.3121 7.89229 35.4204 7.99613C35.637 8.20383 35.637 8.41152 35.4204 8.61921L34.9871 9.34613"
                      fill="black"
                    />
                    <path
                      opacity="0.3"
                      d="M28.163 27L43.3278 19.7308L15.1647 6.23077L0 13.5L28.163 27Z"
                      fill="#262626"
                    />
                    <path
                      d="M28.7047 22.6385L41.1615 16.9269L14.0816 3.84232L1.62488 9.55385L28.7047 22.6385Z"
                      fill="#2D3134"
                    />
                    <path
                      d="M23.9386 16.7192C23.0721 16.3039 22.3138 16.3039 21.7722 16.5115L20.5807 17.1346C19.9308 17.4462 19.6058 17.9654 19.6058 18.9C19.6058 20.5615 21.014 22.6385 22.7471 23.4692C23.6137 23.8846 24.3719 23.8846 25.0218 23.6769C25.0218 23.6769 26.2133 23.0539 26.3216 22.95C26.8632 22.6385 27.1882 22.1192 27.1882 21.2885C27.0799 19.6269 25.6717 17.6539 23.9386 16.7192Z"
                      fill="#2D3134"
                    />
                    <path
                      opacity="0.39"
                      d="M24.9135 23.6769C25.1301 23.5731 26.105 23.0538 26.2133 23.0538C26.7549 22.7423 27.0798 22.2231 27.0798 21.3923C27.0798 20.6654 26.8632 19.9384 26.4299 19.3154L25.2384 19.9384C25.6717 20.6654 25.8883 21.3923 25.8883 22.0154C25.8883 22.8461 25.5634 23.3654 24.9135 23.6769Z"
                      fill="black"
                    />
                    <path
                      d="M22.6388 18.1731C21.3389 17.55 20.2557 18.0692 20.2557 19.3154C20.2557 20.5615 21.3389 22.1192 22.6388 22.7423C23.9386 23.3654 25.0218 22.8462 25.0218 21.6C25.1301 20.3538 24.0469 18.7962 22.6388 18.1731ZM24.2636 19.7308C24.4802 20.0423 24.5885 20.3538 24.3719 20.4577C24.2636 20.5615 23.5053 20.4577 23.1804 20.3538C23.1804 20.25 23.072 20.25 23.072 20.1462C23.1804 19.8346 23.397 19.3154 23.6136 19.2115C23.722 19.1077 24.0469 19.3154 24.2636 19.7308ZM22.6388 18.3808C22.9637 18.5885 23.2887 18.7962 23.2887 19.0038C23.2887 19.2115 22.9637 19.7308 22.7471 19.9385C22.7471 19.9385 22.6388 19.9385 22.6388 19.8346H22.5304C22.3138 19.4192 21.9888 18.6923 21.9888 18.4846C22.0972 18.1731 22.3138 18.1731 22.6388 18.3808ZM21.1223 18.1731C21.3389 18.0692 21.6639 18.0692 21.8805 18.3808C21.9888 18.5885 22.3138 19.4192 22.4221 19.7308C22.3138 19.7308 22.3138 19.7308 22.3138 19.8346C21.9888 19.5231 21.2306 19.0038 21.1223 18.7962C20.7973 18.4846 20.9057 18.2769 21.1223 18.1731ZM20.4724 19.4192C20.4724 19.1077 20.5807 18.9 20.9057 19.0038C21.1223 19.1077 21.7722 19.7308 22.0972 20.0423V20.25C21.7722 20.25 21.1223 20.25 20.9057 20.1462C20.5807 20.0423 20.4724 19.7308 20.4724 19.4192ZM21.1223 21.1846C20.9057 20.8731 20.7973 20.5615 21.014 20.4577C21.1223 20.3538 21.8805 20.4577 22.2055 20.5615C22.2055 20.6654 22.3138 20.6654 22.3138 20.7692C22.2055 21.0808 21.9888 21.6 21.7722 21.7038C21.6639 21.8077 21.3389 21.4962 21.1223 21.1846ZM22.6388 22.5346C22.3138 22.3269 21.9888 22.1192 21.9888 21.9115C21.9888 21.7038 22.3138 21.1846 22.5304 20.9769C22.5304 20.9769 22.6388 20.9769 22.6388 21.0808H22.7471C22.9637 21.4962 23.2887 22.2231 23.2887 22.4308C23.2887 22.7423 23.072 22.7423 22.6388 22.5346ZM24.2636 22.6385C24.0469 22.7423 23.722 22.7423 23.5053 22.4308C23.397 22.2231 23.072 21.3923 22.9637 21.0808C23.072 21.0808 23.072 21.0808 23.072 20.9769C23.397 21.2885 24.1552 21.8077 24.2636 22.0154C24.5885 22.3269 24.4802 22.5346 24.2636 22.6385ZM24.4802 21.9115C24.2636 21.8077 23.6136 21.1846 23.2887 20.8731V20.6654C23.6136 20.6654 24.2636 20.6654 24.4802 20.7692C24.8052 20.8731 24.9135 21.1846 24.9135 21.4962C24.9135 21.8077 24.8052 22.0154 24.4802 21.9115Z"
                      fill="#C4C6CC"
                    />
                    <path
                      opacity="0.06"
                      d="M22.8554 22.6385C21.5556 22.0154 20.4724 20.4577 20.4724 19.2115C20.4724 18.5885 20.689 18.1731 21.1223 17.9654C20.5807 18.1731 20.2557 18.5885 20.2557 19.3154C20.2557 20.5615 21.3389 22.1192 22.6388 22.7423C23.2887 23.0539 23.9386 23.0539 24.3719 22.8462C23.9386 22.95 23.5053 22.95 22.8554 22.6385Z"
                      fill="black"
                    />
                    <path
                      opacity="0.06"
                      d="M25.8884 22.0154C25.8884 23.6769 24.4802 24.4039 22.7471 23.5731C21.014 22.7423 19.6058 20.6654 19.6058 19.0039C19.6058 17.3423 21.014 16.6154 22.7471 17.4462C24.4802 18.1731 25.8884 20.25 25.8884 22.0154Z"
                      fill="black"
                    />
                    <path
                      d="M7.69061 9.03461C6.82405 8.61922 6.06582 8.61922 5.52422 8.82691L4.22439 9.44999C3.68279 9.65768 3.24951 10.2808 3.24951 11.1115C3.24951 12.7731 4.65766 14.85 6.39077 15.6808C7.25733 16.0961 8.01557 16.0961 8.66548 15.8885C8.66548 15.8885 9.857 15.2654 9.96531 15.1615C10.5069 14.85 10.8319 14.3308 10.8319 13.5C10.8319 11.9423 9.42372 9.86538 7.69061 9.03461Z"
                      fill="#2D3134"
                    />
                    <path
                      opacity="0.39"
                      d="M8.66565 15.8885C8.88229 15.7846 9.85716 15.2654 9.96548 15.2654C10.5071 14.9538 10.832 14.4346 10.832 13.6038C10.832 12.8769 10.6154 12.15 10.1821 11.5269L8.99061 12.15C9.42389 12.8769 9.64052 13.6038 9.64052 14.2269C9.64052 15.0577 9.31557 15.6808 8.66565 15.8885Z"
                      fill="black"
                    />
                    <path
                      d="M6.39084 10.3846C5.09101 9.76152 4.00781 10.2807 4.00781 11.5269C4.00781 12.7731 5.09101 14.3307 6.39084 14.9538C7.69067 15.5769 8.77387 15.0577 8.77387 13.8115C8.88219 12.5654 7.79899 11.0077 6.39084 10.3846ZM8.01563 11.9423C8.23227 12.2538 8.34059 12.5654 8.12395 12.6692C8.01563 12.7731 7.25739 12.6692 6.93244 12.5654C6.93244 12.4615 6.82412 12.4615 6.82412 12.3577C6.93244 12.0461 7.14908 11.5269 7.36571 11.4231C7.47403 11.3192 7.79899 11.6307 8.01563 11.9423ZM6.39084 10.5923C6.7158 10.8 7.04076 11.0077 7.04076 11.2154C7.04076 11.4231 6.7158 11.9423 6.49916 12.15C6.49916 12.15 6.39084 12.15 6.39084 12.0461H6.28252C6.06588 11.6307 5.74092 10.9038 5.74092 10.6961C5.84924 10.3846 6.06588 10.3846 6.39084 10.5923ZM4.87437 10.4884C5.09101 10.3846 5.41596 10.3846 5.6326 10.6961C5.74092 10.9038 6.06588 11.7346 6.1742 12.0461C6.06588 12.0461 6.06588 12.0461 6.06588 12.15C5.74092 11.8384 4.98269 11.3192 4.87437 11.1115C4.54941 10.8 4.65773 10.5923 4.87437 10.4884ZM4.22445 11.6307C4.22445 11.3192 4.33277 11.1115 4.65773 11.2154C4.87437 11.3192 5.52428 11.9423 5.84924 12.2538V12.4615C5.52428 12.4615 4.87437 12.4615 4.65773 12.3577C4.33277 12.2538 4.22445 11.9423 4.22445 11.6307ZM4.87437 13.3961C4.65773 13.0846 4.54941 12.7731 4.76605 12.6692C4.87437 12.5654 5.6326 12.6692 5.95756 12.7731C5.95756 12.8769 6.06588 12.8769 6.06588 12.9807C5.95756 13.2923 5.74092 13.8115 5.52428 13.9154C5.41597 14.0192 5.09101 13.7077 4.87437 13.3961ZM6.39084 14.7461C6.06588 14.5384 5.74092 14.3307 5.74092 14.1231C5.74092 13.9154 6.06588 13.3961 6.28252 13.1884C6.28252 13.1884 6.39084 13.1884 6.39084 13.2923H6.49916C6.7158 13.7077 7.04076 14.4346 7.04076 14.6423C7.04076 14.9538 6.82412 14.9538 6.39084 14.7461ZM8.01563 14.9538C7.79899 15.0577 7.47403 15.0577 7.25739 14.7461C7.14908 14.5384 6.82412 13.7077 6.7158 13.3961C6.82412 13.3961 6.82412 13.3961 6.82412 13.2923C7.14908 13.6038 7.90731 14.1231 8.01563 14.3307C8.34059 14.6423 8.23227 14.85 8.01563 14.9538ZM8.23227 14.1231C8.01563 14.0192 7.36571 13.3961 7.04076 13.0846V12.8769C7.36571 12.8769 8.01563 12.8769 8.23227 12.9807C8.55723 13.0846 8.66555 13.3961 8.66555 13.7077C8.66555 14.0192 8.55723 14.2269 8.23227 14.1231Z"
                      fill="#C4C6CC"
                    />
                    <path
                      opacity="0.06"
                      d="M6.60748 14.85C5.30765 14.2269 4.22445 12.6692 4.22445 11.4231C4.22445 10.8 4.44109 10.3846 4.87437 10.1769C4.33277 10.3846 4.00781 10.8 4.00781 11.5269C4.00781 12.7731 5.09101 14.3308 6.39084 14.9538C7.04076 15.2654 7.69067 15.2654 8.12395 15.0577C7.69067 15.2654 7.25739 15.1615 6.60748 14.85Z"
                      fill="black"
                    />
                    <path
                      opacity="0.06"
                      d="M9.64036 14.2269C9.64036 15.8885 8.2322 16.6154 6.49909 15.7846C4.76598 14.9539 3.24951 12.8769 3.24951 11.1115C3.24951 9.34616 4.65766 8.72308 6.39077 9.55385C8.2322 10.4885 9.64036 12.5654 9.64036 14.2269Z"
                      fill="black"
                    />
                    <path
                      d="M36.0704 10.3846L30.3294 4.15385L21.6639 0L15.3814 0.519231L11.2652 0.207692L1.51648 4.88077V9.03461L2.70799 9.76154C3.24959 8.61923 4.76606 8.20385 6.39085 9.03461C8.3406 9.96923 9.85707 12.0462 10.182 13.9154L18.8476 18.1731C19.0642 16.4077 20.689 15.7846 22.6388 16.7192C24.5885 17.6538 26.2133 19.8346 26.4299 21.8077L30.7627 23.5731L42.2446 18.1731V14.0192L36.0704 10.3846Z"
                      fill="#CC291F"
                    />
                    <path
                      d="M20.364 9.55383L30.3294 4.67307L35.3121 10.1769L25.3467 14.9538L20.364 9.55383Z"
                      fill="#3399CC"
                    />
                    <path
                      d="M34.9871 9.86539L25.0217 14.6423L25.3467 14.9538L35.3121 10.1769L34.9871 9.86539Z"
                      fill="#2D3134"
                    />
                    <path
                      opacity="0.15"
                      d="M22.5304 8.51537L30.3294 4.67307L35.3121 10.1769L22.5304 8.51537Z"
                      fill="black"
                    />
                    <path
                      d="M16.2479 0.830765L19.4975 0.519226L10.7236 4.67307L7.36572 4.98461L16.2479 0.830765Z"
                      fill="#3399CC"
                    />
                    <path
                      opacity="0.39"
                      d="M16.1396 2.07693L10.7236 4.67309L7.36572 4.98463L16.1396 2.07693Z"
                      fill="white"
                    />
                    <path
                      d="M42.2446 14.5385V16.4077L40.6198 17.1346V16.3038C40.6198 15.9923 40.7282 15.6808 40.9448 15.3692C41.1614 15.1615 41.3781 14.9538 41.5947 14.85L42.2446 14.5385ZM30.8711 20.0423L32.0626 19.5231C32.2792 19.4192 32.6042 19.4192 32.8208 19.6269C32.9292 19.7308 33.0375 19.9385 33.0375 20.0423V20.7692L30.8711 21.8077V20.0423Z"
                      fill="white"
                    />
                    <path
                      d="M30.8711 20.0423L30.3295 19.7308V21.6L30.8711 21.8077V20.0423Z"
                      fill="#FFCC00"
                    />
                    <path
                      opacity="0.39"
                      d="M31.8099 20.2376C31.5833 20.5045 31.55 20.8383 31.7356 20.9831C31.9212 21.1279 32.2553 21.029 32.4819 20.7621C32.7085 20.4952 32.7418 20.1614 32.5562 20.0166C32.3706 19.8718 32.0365 19.9708 31.8099 20.2376Z"
                      fill="#2D3134"
                    />
                    <path
                      opacity="0.39"
                      d="M31.4113 20.2218C31.1847 20.4887 31.1515 20.8225 31.3371 20.9673C31.5227 21.1121 31.8568 21.0131 32.0834 20.7463C32.31 20.4794 32.3432 20.1456 32.1576 20.0008C31.972 19.856 31.6379 19.9549 31.4113 20.2218Z"
                      fill="#2D3134"
                    />
                    <path
                      opacity="0.39"
                      d="M41.3212 15.5256C41.0946 15.7925 41.0614 16.1263 41.247 16.2711C41.4326 16.4159 41.7667 16.317 41.9933 16.0501C42.2199 15.7832 42.2531 15.4494 42.0675 15.3046C41.8819 15.1598 41.5478 15.2587 41.3212 15.5256Z"
                      fill="#2D3134"
                    />
                    <path
                      opacity="0.39"
                      d="M40.8121 15.8165C40.5855 16.0834 40.5522 16.4171 40.7378 16.5619C40.9234 16.7068 41.2575 16.6078 41.4841 16.3409C41.7107 16.074 41.744 15.7403 41.5584 15.5955C41.3728 15.4507 41.0387 15.5496 40.8121 15.8165Z"
                      fill="#2D3134"
                    />
                    <path
                      d="M34.1206 19.0038L39.5366 16.4077V17.6538L34.1206 20.25V19.0038Z"
                      fill="#2D3134"
                    />
                    <path
                      d="M2.16647 5.71154L1.62488 5.50385V6.75L2.16647 7.06154V5.71154Z"
                      fill="#FF9900"
                    />
                    <path
                      d="M14.4064 10.6961L24.1552 15.3692L19.1725 9.76153L14.4064 7.47692V10.6961ZM13.5399 7.16538L11.1568 6.02307L6.28247 6.74999L13.5399 10.2808V7.16538Z"
                      fill="#3399CC"
                    />
                    <path
                      opacity="0.15"
                      d="M14.948 10.6961V7.78846L14.4064 7.47692V10.6961L24.1552 15.3692L23.7219 14.85L14.948 10.6961ZM6.82407 6.74999L11.2652 6.02307H11.1568L6.28247 6.74999L13.5399 10.2808V9.96923L6.82407 6.74999Z"
                      fill="black"
                    />
                    <path
                      opacity="0.06"
                      d="M25.2385 15.5769L19.4976 9.34616L10.5071 5.19231L4.65782 5.71154L1.62488 4.98462V9.13847L2.81639 9.86539C3.24967 8.61923 4.76614 8.20385 6.39093 9.03462C8.34068 9.96923 9.85715 12.0462 10.1821 13.9154L10.3987 14.0192L18.8477 18.2769C19.0643 16.5115 20.6891 15.8885 22.6388 16.8231C24.5886 17.7577 26.2134 19.9385 26.43 21.9115L30.7628 23.6769V19.5231L25.2385 15.5769Z"
                      fill="black"
                    />
                    <path
                      d="M1.40808 8.10001L2.49128 8.61924V10.1769L1.40808 9.6577V8.10001Z"
                      fill="#CC291F"
                    />
                    <path
                      opacity="0.39"
                      d="M1.40808 8.10001L2.49128 8.61924V10.1769L1.40808 9.6577V8.10001Z"
                      fill="black"
                    />
                    <path
                      d="M2.49128 8.61922V10.1769L2.70791 9.86538V8.30768L1.62472 7.78845L1.40808 8.09999L2.49128 8.61922ZM30.6543 23.8846L43.111 17.9654V16.9269L30.6543 22.8461L29.5711 22.3269V23.3654L30.6543 23.8846Z"
                      fill="#CC291F"
                    />
                    <path
                      opacity="0.39"
                      d="M30.6544 23.8846L43.1111 17.9654V16.9269L30.6544 22.8461L29.5712 22.3269V23.3654L30.6544 23.8846Z"
                      fill="black"
                    />
                    <path
                      d="M30.6544 22.3269L42.5695 16.6154L43.1111 16.9269L30.6544 22.8462L29.5712 22.3269L30.1128 22.1192L30.6544 22.3269Z"
                      fill="#CC291F"
                    />
                    <path
                      opacity="0.39"
                      d="M30.8711 20.0423L33.0375 20.7692L30.8711 21.8077V20.0423ZM42.2446 14.5385V16.4077L40.6198 17.1346L42.2446 14.5385Z"
                      fill="white"
                    />
                    <path
                      d="M23.6136 15.0577L22.5304 13.6038C22.3138 13.3961 22.0971 13.2923 21.7722 13.2923L20.4723 13.3961C20.2557 13.3961 20.0391 13.6038 20.0391 13.8115C20.0391 14.0192 20.2557 14.2269 20.4723 14.2269L21.9888 14.4346L23.6136 15.0577Z"
                      fill="#CC291F"
                    />
                    <path
                      opacity="0.39"
                      d="M23.6136 15.0577L22.5304 13.6038C22.3138 13.3961 22.0971 13.2923 21.7722 13.2923L20.4723 13.3961C20.2557 13.3961 20.0391 13.6038 20.0391 13.8115C20.0391 14.0192 20.2557 14.2269 20.4723 14.2269L21.9888 14.4346L23.6136 15.0577Z"
                      fill="black"
                    />
                    <path
                      d="M27.8381 12.3577C27.8381 12.4615 27.9464 12.4615 28.0547 12.4615L32.9291 11.2154C33.0374 11.2154 33.0374 11.1115 33.0374 11.0077C33.0374 10.9038 32.9291 10.9038 32.8208 10.9038L27.9464 12.15C27.8381 12.15 27.8381 12.2538 27.8381 12.3577ZM25.1301 13.7077C25.1301 13.8115 25.2384 13.8115 25.3468 13.8115L30.2211 12.5654C30.3295 12.5654 30.3295 12.4615 30.3295 12.3577C30.3295 12.2538 30.2211 12.2538 30.1128 12.2538L25.2384 13.5C25.1301 13.5 25.1301 13.6038 25.1301 13.7077Z"
                      fill="black"
                    />
                    <path
                      opacity="0.5"
                      d="M33.904 10.8C34.0123 10.1769 33.904 9.55383 33.4707 9.24229C32.7125 8.72306 31.5209 9.0346 30.6544 10.0731C29.8962 10.9038 29.6795 11.9423 30.1128 12.5654L30.871 12.2538C30.5461 11.8384 30.6544 11.0077 31.196 10.3846C31.8459 9.65768 32.7125 9.34614 33.2541 9.76152C33.579 9.96921 33.579 10.4884 33.3624 11.0077L33.904 10.8Z"
                      fill="black"
                    />
                    <path
                      opacity="0.39"
                      d="M36.0703 10.3846L25.2384 15.5769L19.4974 9.34615L30.3294 4.15384L36.0703 10.3846ZM42.2445 14.0192L30.871 19.5231V22.1192L42.2445 16.7192V14.0192Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </Marker>
        ) : null}
      </>
    );
  };

  return (
    <div className="map_view_area">
      <Map
        mapboxAccessToken="pk.eyJ1IjoiZGVlcGFrc2luZ2g5IiwiYSI6ImNsYXZ6ZmEyNTAyM3Azb3A3MzI0amw1MGwifQ.XR9N3Q6tAdjoLLybOqj_ig"
        {...viewport}
        onMove={(evt) => setViewPort(evt.viewState)}
        onViewportChange={(viewpor) => {
          setZoom(viewpor.zoom);
          setViewPort(viewpor);
        }}
        style={{ borderRadius: "12px", width: "100%", height: "100%" }}
        mapStyle="mapbox://styles/mapbox/streets-v12"
      >
        {vehicleDatas.map(_rendervehiclemarker)}
      </Map>
    </div>
  );
};

export default Maps;
